import { createContext, useContext, useState } from "react";

/** A retained view owns its session until closed, but only the visible view owns UI effects. */
export const ViewActivityContext = createContext(true);
export const useViewActive = () => useContext(ViewActivityContext);

/** Portals must follow their view even though their DOM lives outside its hidden panel. */
export function useViewOpenState({
  open,
  defaultOpen = false,
  onOpenChange,
}: {
  readonly open?: boolean;
  readonly defaultOpen?: boolean;
  readonly onOpenChange?: (open: boolean) => void;
}) {
  const active = useViewActive();
  const [localOpen, setLocalOpen] = useState(defaultOpen);
  if (!active && localOpen) setLocalOpen(false);
  return {
    open: active && (open ?? localOpen),
    onOpenChange: (next: boolean) => {
      if (!active) return;
      setLocalOpen(next);
      onOpenChange?.(next);
    },
  };
}
